"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.root = void 0;
var react_1 = require("@emotion/react");
var root = function (state) { return (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  ", ";\n  ", "\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  ", ";\n  ", "\n"])), !state.disablePadding &&
    "\n  padding-top: 8px;\n  padding-bottom: 8px;\n", state.subheader && 'padding-top: 0;'); };
exports.root = root;
var templateObject_1;
//# sourceMappingURL=List.style.js.map